import { createFileRoute } from '@tanstack/react-router';
import { LeaderboardPage } from '@/pages/Leaderboard';
import { z } from 'zod';

const leaderboardSearchSchema = z.object({
  game: z.enum(['cabinet-transformer', 'automation-drop', 'all']).optional().default('all'),
  page: z.number().optional().default(1),
  limit: z.number().optional().default(20),
});

export const Route = createFileRoute('/leaderboard')({
  validateSearch: leaderboardSearchSchema,
  component: LeaderboardPage,
});
